<!-- <template>
	<type-wrapper class="type-K" regular>
		<type-grid :row="row" margin v-for="(item, index) in showData" :key="index">
			<div class="type-K-data">
				<type-image width="50%" mode="widthFix" :src="item.logo"></type-image>
				<type-text type="title" size="3" padding="25px 0" v-if="item.title">{{ item.title }}</type-text>
				<type-text type="content" size="6" v-if="item.content">{{ item.content }}</type-text>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// N分栏不同主题图文说明
	import mixin from '../mixin.js'
	export default {
		name: 'type-K',
		mixins: [ mixin ],
		computed: {
			row() {
				return this.showData.length > 3 ? 3 : this.showData.length;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-K{
		display: flex;
		flex-wrap: wrap;
		.type-K-data{
			padding: 20px;
			text-align: center;
			background-color: #FFFFFF;
			box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
		}
	}
</style>
 -->

 <template>
    <type-wrapper class="type-K" regular>
        <type-grid :row="row" margin v-for="(item, index) in showData" :key="index">
            <div class="type-K-data">
                <type-image width="90%" mode="widthFix" :src="item.logo"></type-image>
                <type-text type="title" size="2" padding="25px 0" v-if="item.title">{{ item.title }}</type-text>
                <type-text type="content" size="9" v-if="item.content">{{ item.content }}</type-text>
            </div>
        </type-grid>
    </type-wrapper>
</template>

<script>
    // N分栏不同主题图文说明
    import mixin from '../mixin.js'
    export default {
        name: 'type-K',
        mixins: [ mixin ],
        computed: {
            // Override the mixin's showData with custom transformation
            showData() {
                console.log('=== TypeK showData computation ===');
                
                // Get raw data from mixin
                const rawData = this.typeData.data;
                console.log('Raw typeData.data:', rawData);
                
                if (!Array.isArray(rawData)) {
                    console.log('TypeK: No valid array found');
                    return [];
                }

                // Transform each item
                const transformedData = rawData.map((item, index) => {
                    console.log(`\n=== Processing TypeK Item ${index} ===`);
                    console.log('Raw item keys:', Object.keys(item));
                    
                    // Log all text-related properties to see what's available
                    const textProps = {};
                    Object.keys(item).forEach(key => {
                        if (typeof item[key] === 'string' && item[key].length > 0) {
                            textProps[key] = item[key];
                        }
                    });
                    console.log('TypeK Text properties:', textProps);
                    
                    // Check for HTML content
                    const htmlProps = {};
                    Object.keys(item).forEach(key => {
                        if (typeof item[key] === 'string' && item[key].includes('<p>')) {
                            htmlProps[key] = item[key];
                        }
                    });
                    console.log('TypeK HTML properties:', htmlProps);
                    
                    const transformedItem = {
                        logo: item.logo || item.photo || item.image || '',
                        title: item.title || item.name || '',
                        content: item.content || item.description || ''
                    };

                    console.log('TypeK Final transformed item:', transformedItem);
                    return transformedItem;
                });

                console.log('Final TypeK transformed data:', transformedData);
                return transformedData;
            },
            
            row() {
                return this.showData.length > 3 ? 3 : this.showData.length;
            }
        }
    }
</script>

<style scoped lang="less">
    .type-K{
        display: flex;
        flex-wrap: wrap;
        .type-K-data{
            padding: 20px;
            text-align: center;
            background-color: #FFFFFF;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
        }
    }
</style>